<template>
  <div class="verification">
    <div class="verification-loading" v-if="loader">
      <Loading></Loading>
    </div>
    <div class="verification-container" v-if="!loader">
      <div class="verification-container-status">
        <img v-if="!verificationStatus" class="status-logo" src="@/assets/error@2x.svg" alt="" />
        <img v-else class="status-logo" src="@/assets/success@2x.svg" alt="" />
        <p v-if="!verificationStatus && alreadyVerified" class="font-medium">
          Email is already verified.
        </p>
        <p v-if="!verificationStatus && !alreadyVerified" class="font-large">
          Verification Unsuccessful
        </p>
        <p v-if="verificationStatus" class="font-large">
          Verification Successful!
        </p>
        <p v-if="!verificationStatus && !alreadyVerified" class="font-medium">
          Sorry! Your account has not verified.
        </p>
        <p v-if="verificationStatus" class="font-medium">
          <!-- Your account has been verified successfully. -->
          Now you can login to your application and enjoy.
        </p>
        <p v-if="!verificationStatus && !alreadyVerified" class="font-medium">
          Please try later.
        </p>
        <!-- <p v-if="verificationStatus" class="font-medium">
          Now you can <router-link to="/">login</router-link> and explore.
        </p> -->
      </div>
      <!-- <div class="verification-container-appLogo">
        <img src="@/assets/icons/vlive_logo.png" alt="" />
      </div> -->
    </div>
  </div>
</template>

<script>
import Loading from "@/components/loading.vue";
var sha1 = require("sha1");
import CryptoJS from "crypto-js";

export default {
  data() {
    return {
      verificationStatus: false,
      alreadyVerified: false,
      loader: true,
      formError: null,
      providerId: null,
      clientKey: null,
      deviceRegPayload: {},
    };
  },
  created() {
    // this.clientKey = null;

    this.getQueryParams();

    this.deviceRegister()
      .then((payload) => {
        console.log("THE HASH --- ", payload);

        if (!payload) {
          return;
        }
        fetch(
          `https://vsms.mobiotics.com/prodv3/subscriberv2/v1/device/register/${this.providerId}?hash=${payload.hash}`,
          {
            method: "POST",
            body: payload.enc,
          }
        )
          .then((data) => {
            return data.json();
          })
          .then((data) => {
            console.log("THE ACTUAL DATA ---", data);

            localStorage.setItem("deviceToken", data.success);

            this.verifyEmail();
          })
          .catch((error) => {
            console.log("AN ERROR OCCURED AT DEVICE REGISTER ", error);
          });

        // this.verifyEmail();
      })
      .catch((err) => {
        console.log("AN ERROR OCCURED", err);
      });
  },
  methods: {
    encodeUri(data) {
      var obj = {
        "%20": "+",
        "%21": "!",
        "%2A": "*",
        "%27": "'",
        "%28": "(",
        "%29": ")",
        "%3B": ";",
        "%3A": ":",
        "%40": "@",
        "%26": "&",
        "%3D": "=",
        "%2B": "+",
        "%24": "$",
        "%2C": ",",
        "%2F": "/",
        "%3F": "?",
        "%25": "%",
        "%23": "#",
        "%5B": "[",
        "%5D": "]",
      };

      for (let i in obj) {
        data = data.replace(new RegExp(i, "g"), obj[i]);
      }

      return data;
    },

    getQueryParams() {
      let queryParams = window.location.href.split("?")[1];
      let arr = queryParams.split("&");
      this.deviceRegPayload = {};
      arr.forEach((element, index) => {
        let value = element.split("=")[1];
        if (index === 0) {
          this.deviceRegPayload.email = this.encodeUri(value);
        } else if (index === 1) {
          this.deviceRegPayload.token = value;
        } else if (index === 2) {
          this.deviceRegPayload.providerid = value;
          this.providerId = value;
        }
      });

      this.clientKey = this.providerId === "noorplay" ? "btJ85rtEsEhyrE0t" : "";
    },

    Encrypt(deviceid, key) {
      var C = CryptoJS;
      var plainText = C.enc.Utf8.parse(deviceid);
      key = C.enc.Utf8.parse(key);
      var aes = C.algo.AES.createEncryptor(key, {
        mode: C.mode.ECB,
        padding: C.pad.Pkcs7,
        iv: key,
      });
      var encrypted = aes.finalize(plainText);
      encrypted = C.enc.Base64.stringify(encrypted);
      encrypted = this.encode_url(encrypted);
      return encrypted;
    },

    encode_url(data) {
      /*eslint-disable */
      var data1 = data.replace(/\+/g, "-");
      /*eslint-disable */
      data1 = data.replace(/\//g, "_");
      /*eslint-disable */
      data1 = data.replace(/\=/g, ",");
      return data1;
    },

    verifyEmail() {
      // let queryParams = window.location.href.split("?")[1];
      // let arr = queryParams.split("&");
      // let payload = {};
      // arr.forEach((element, index) => {
      //   let value = element.split("=")[1];
      //   if (index === 0) {
      //     payload.email = this.encodeUri(value);
      //   } else if (index === 1) {
      //     payload.token = value;
      //   } else if (index === 2) {
      //     payload.providerid = value;
      //     this.providerId = value;
      //   }
      // });
      this.loader = true;
      console.log("verification payload", this.deviceRegPayload);
      this.emailConfirm(this.deviceRegPayload)
        .then((response) => {
          this.loader = false;
          console.log("email verify response", response);
          if (response.reason) {
            this.verificationStatus = false;
            if (response.errorcode === 6009) {
              this.alreadyVerified = true;
            }
          } else if (response.success) {
            this.verificationStatus = true;
          } else {
            this.verificationStatus = false;
          }
        })
        .catch((error) => {
          if (error) {
            this.verificationStatus = false;
          }
        });
    },

    toFormUrlEncoded(object) {
      return Object.entries(object)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join("&");
    },

    emailConfirm(payload) {
      let env = this.providerId === "net54321" ? "prodv2" : "prodv3";
      return new Promise((resolve, reject) => {
        let data = this.toFormUrlEncoded(payload);
        fetch(`https://vsms.mobiotics.com/${env}/subscriberv2/v1/subscriber/emailconfirm`, {
          method: "POST",
          body: data,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${localStorage.getItem("deviceToken")}`,
          },
        })
          .then((response) => {
            if (response.status == 200 && response.ok) {
              return response.json();
            } else {
              return response.json();
            }
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    deviceRegister() {
      //generating random number

      var uniqueId = localStorage.getItem("random");
      let newUniqueId = "";
      if (!uniqueId) {
        newUniqueId = Math.round(Math.random() * 1e16).toString();
        localStorage.setItem("random", newUniqueId);
      }
      return new Promise((resolve) => {
        let xyz = {
          deviceid: uniqueId ? uniqueId : newUniqueId,
          devicetype: "PC",
          providerid: this.providerId,
        };

        let res = {
          hash: sha1(JSON.stringify(xyz)),
          enc: this.Encrypt(JSON.stringify(xyz), this.clientKey),
          providerid: this.providerId,
        };

        resolve(res);
      });
    },
  },
  components: {
    Loading,
  },
};
</script>

<style lang="scss" scoped>
.verification {
  &-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
  }
  &-container {
    display: grid;
    min-height: 100vh;
    justify-content: center;
    &-status {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .status-logo {
        margin-bottom: 1.6rem;
        height: 55px;
        width: 55px;
      }
      .font-large {
        color: #efeff4;
        font-family: "Helvetica Neue Bold", sans-serif;
        font-size: 32px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 39px;
        margin-bottom: 1.4rem;
      }
      .font-medium {
        color: #868688;
        font-family: "Helvetica Neue", sans-serif;
        font-size: 16px;
        letter-spacing: 0;
        line-height: 23px;
      }
    }
    &-appLogo {
      text-align: center;
      img {
        height: 40px;
        width: 117px;
      }
    }
  }
}
</style>
